<template>
  <component-wrapper class="country-selection-fi">
    <grid-container-fi :container="false">
      <div class="country-selection-fi__header fi-col-span-12">
        <headline-fi
          v-if="title"
          :size="setTitleFontSize"
          class="country-selection-fi__title"
          tag="div"
          color="brand"
          :html-content="title"
        />
        <headline-fi
          v-if="subtitle"
          :size="setHeadlineFontSize"
          class="country-selection-fi__subtitle"
          tag="h1"
          :html-content="subtitle"
        />
        <!-- eslint-disable vue/no-v-html -->
        <p
          v-if="description"
          class="country-selection-fi__description"
          v-html="description"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </grid-container-fi>

    <country-selection-list-fi />
  </component-wrapper>
</template>

<script setup lang="ts">
import { HeadlineFi } from 'atoms';
import { computed } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import CountrySelectionListFi from '@/components/country-selection-list-fi/CountrySelectionListFi.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useBreakpoints } from '@/composables/breakpoint';
import { useDict, useFischer } from '@/composables/fischerPlugin';
import { useNavigationStore } from '@/store/pinia/navigation';

defineOptions({ name: 'CountrySelectionFi' });

const fischer = useFischer();
const dict = useDict();
const { isMD, isSM } = useBreakpoints();
const navigationStore = useNavigationStore();

const title = computed(() =>
  dict.get('global-Labels.Country-Selection.Title', [fischer.brandName()]),
);
const subtitle = computed(() => dict.get('global-Labels.Country-Selection.Subtitle'));
const description = computed(() => dict.get('global-Labels.Country-Selection.Description'));

const setTitleFontSize = computed(() => {
  if (isMD.value) return 30;
  if (isSM.value) return 24;
  return 21;
});

const setHeadlineFontSize = computed(() => {
  if (isMD.value) return 60;
  return 36;
});

navigationStore.setIsCountrySelectPage(true);
</script>

<style src="./country-selection-fi" />
